/**
 * El menú completo como lo edita la Consola (controller/plataforma/menu).
 * Lo que se consulta es exactamente lo que se manda al guardar.
 */
export class HojaMenu {
  id: number;
  nombre: string;
  icono: string | null = null;
  /** Sólo lectura: identidad para permisos; nunca cambia. */
  factory: string;
  /** Sólo lectura: quién tiene el sitio la ve. */
  sitio: string;
  ruta: string | null = null;
  tipo: string | null = null;
  orden: number | null = null;
  /** Sólo lectura: cuántos perfiles la tienen. */
  perfiles: number | null = null;
}

export class GrupoMenu {
  /** Identidad al guardar (nombre normalizado al consultar). Nula en un grupo nuevo. */
  clave: string | null = null;
  nombre = "";
  icono: string | null = null;
  /** "fijo" = abajo del menú, separado de los grupos. */
  seccion: string | null = null;
  orden: number | null = null;
  tipo: string | null = null;
  /** Sitio donde nace un grupo nuevo sin hojas. */
  sitio: string | null = null;
  sitios: string[] = [];
  ids: number[] = [];
  /** «Sin grupo»: hojas cuyo padre ya no existe. Lo que se deje aquí no se toca. */
  virtual = false;
  hojas: HojaMenu[] = [];
}

export class MenuEstructura {
  grupos: GrupoMenu[] = [];
  sitios: string[] = [];
}
